// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"container_mainContainer__DFrMY","innerContainerWidth":"container_innerContainerWidth__Rc6uf"};